module.exports = __webpack_public_path__ + "img/Small-2-Bevel-Attachment-27.67dc4ac2.png";